export const percentualTresDois = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: ' %',
    precision: 2,
    masked: false
}

export const percentualTresQuatro = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: ' %',
    precision: 4,
    masked: false
}

export const valorLatitudeLongitude = {
    decimal: '.',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 6,
    masked: false
}

export const valorQuinzeDois = {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 2,
    masked: false
}

export const  pesoTresDois = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 2,
    masked: false
}

export const quantidadeQuinzeSeis = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 6,
    masked: false
}

export const quantidadeQuinzeTres = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 3,
    masked: false
}

export const quantidadeQuinzeQuatro = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 4,
    masked: false
}

export const quantidadeQuinzeDois = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 2,
    masked: false
}

export const valorVinteUmDez = {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 10,
    masked: false
}

export const valorQuinzeQuatro = {
    decimal: ',',
    thousands: '.',
    prefix: ' ',
    suffix: '',
    precision: 4,
    masked: false
}

export const percentualDoisSeis = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: ' %',
    precision: 6,
    masked: false
}